<div class="modal">
  <div class="modal__header">
    <div class="grid-row grid-row--aic">
      <div class="grid-col">
        <div class="h3">Are you sure?</div>
      </div>
      <div class="grid-col grid-col--auto">
        <button (click)="closeModal()" type="button" class="modal__close"><svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button>
      </div>
    </div>
  </div>
  <div class="modal__cont">
    <p>Please confirm that you want to delete this recurring payment.</p>
    <div class="mt--125 grid-row grid-row--jcb">
      <div class="grid-col grid-col--auto">
        <button andButton color="default" (click)="closeModal()">Cancel</button>
      </div>
      <div class="grid-col grid-col--auto">
        <button andButton color="negative" type="submit" [isLoading]="requestProcessing$ | async" (click)="delete()">Delete</button>
      </div>
    </div>
  </div>
</div>
